import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firebase-firestore";
import "firebase/analytics";
import "firebase/storage";
import "firebase/performance";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASURE_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

const fire = firebase.initializeApp(firebaseConfig);
fire.analytics();
fire.performance();
export default fire;
